// 售后订单状态枚举（见接口文档 §0.6）
export const AFTER_SALE_STATUS_DIC = [
    { label: '待受理', value: 'WAIT_ACCEPT' },
    { label: '待指派', value: 'WAIT_FOR_ASSIGN' },
    { label: '服务中', value: 'IN_SERVICE' },
    { label: '待确认', value: 'TO_BE_CONFIRMED' },
    { label: '待终审', value: 'TO_BE_THE_FINAL' },
    { label: '待评价', value: 'TO_BE_EVALUATED' },
    { label: '已完成', value: 'COMPLETE' },
    { label: '已作废', value: 'CANCELLED' }
];

// 售后来源枚举
export const AFTER_SALE_SOURCE_DIC = [
    { label: '中台报单报售后', value: 'MAIN_ORDER' },
    { label: '中台手动新建', value: 'MANUAL' },
    { label: '小程序通用码', value: 'QR_COMMON' },
    { label: '小程序一户一码', value: 'QR_ONE_HOUSE' },
    { label: '通用报售后码', value: 'GENERAL_AFTERMARKET' }
];

// 业务线枚举
export const BUSINESS_TYPE_DIC = [
    { label: '防水', value: 'WATERPROOF' },
    { label: '净水', value: 'PURE_WATER' },
    { label: '吊顶', value: 'HANG_CEILING' },
    { label: '工程', value: 'ENGINEERING' },
    { label: '防水项目', value: 'WATERPROOF_PROJECT' },
    { label: '管道', value: 'PIPELINE' },
    { label: '管道试压', value: 'PIPELINE_TESTING' },
    { label: '售后', value: 'AFTER_SALES' },
    { label: '通用报售后码', value: 'GENERAL_AFTERMARKET' }
];

// 是否过保
export const OVERINSURED_DIC = [
    { label: '已过保', value: 'YES' },
    { label: '保内', value: 'NO' },
    { label: '待确认', value: 'PENDING' }
];

// 售后状态标签颜色映射
export const statusTagType = (status) => {
    const map = {
        WAIT_ACCEPT: 'warning',
        WAIT_FOR_ASSIGN: 'warning',
        IN_SERVICE: '',
        TO_BE_CONFIRMED: '',
        TO_BE_THE_FINAL: '',
        TO_BE_EVALUATED: 'success',
        COMPLETE: 'success',
        CANCELLED: 'info'
    };
    return map[status] === undefined ? '' : map[status];
};

export const afterSaleOption = {
    align: 'center',
    menuAlign: 'center',
    headerAlign: 'center',
    border: true,
    index: true,
    indexLabel: '序号',
    selection: false,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: 230,
    labelWidth: 110,
    searchMenuSpan: 6,
    column: [
        {
            label: '售后编号',
            prop: 'afterSaleNo',
            search: true,
            width: 160,
            overHidden: true
        },
        {
            label: '售后来源',
            prop: 'sourceType',
            type: 'select',
            search: true,
            dicData: AFTER_SALE_SOURCE_DIC,
            width: 130
        },
        {
            label: '售后状态',
            prop: 'status',
            type: 'select',
            dicData: AFTER_SALE_STATUS_DIC,
            search: true,
            slot: true,
            width: 100
        },
        {
            label: '是否过保',
            prop: 'overinsuredFlag',
            type: 'select',
            dicData: OVERINSURED_DIC,
            search: true,
            width: 100
        },
        {
            label: '客户姓名',
            prop: 'customName',
            width: 100,
            overHidden: true
        },
        {
            label: '客户电话',
            prop: 'customMobile',
            search: true,
            width: 120
        },
        {
            label: '客户地址',
            prop: 'customAddress',
            minWidth: 180,
            overHidden: true
        },
        {
            label: '工程师姓名',
            prop: 'engineerName',
            search: true,
            width: 100
        },
        {
            label: '工程师电话',
            prop: 'engineerMobile',
            search: true,
            width: 120
        },
        {
            label: '故障现象',
            prop: 'faultPhenomenon',
            minWidth: 180,
            overHidden: true
        },
        {
            label: '创建时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'timestamp',
            width: 160
        },
        {
            label: '创建时间',
            prop: 'timeRange',
            type: 'datetimerange',
            search: true,
            hide: true,
            showColumn: false,
            searchSpan: 8,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'timestamp'
        }
    ]
};
